import { useMemo } from "react";
import {
  createMessageTemplate,
  CreateMessageTemplateRequest,
  getMessageTemplateById,
  MessageTemplateDetail,
  updateMessageTemplate,
  UpdateMessageTemplateRequest,
} from "#/services/messageTemplates";

export type AdminTemplateCreateRequest = CreateMessageTemplateRequest;
export type AdminTemplateUpdateRequest = UpdateMessageTemplateRequest;
export type AdminTemplateDetail = MessageTemplateDetail;

export function useAdminTemplatesApi() {
  return useMemo(
    () => ({
      createTemplate: (payload: AdminTemplateCreateRequest) =>
        createMessageTemplate(payload),
      updateTemplate: (id: string, payload: AdminTemplateUpdateRequest) =>
        updateMessageTemplate(id, payload),
      getTemplate: (id: string, options?: { signal?: AbortSignal }) =>
        getMessageTemplateById(id, options),
    }),
    []
  );
}

export default useAdminTemplatesApi;
